import { toAuthFetchers, toBrowseCategoryFetchers, toClassFetchers, toContractAgreementsFetchers, toFavoritesFetchers, toFiltersFetchers, toMetadataFetchers, toPelotonFetchers, toPostclassLeaderboardFetchers, toStatsTokenFetchers, toStreamFetchers, toSubscriptionsFetchers, toUsersFetchers, toVoiceFetchers, toWorkoutFetchers } from '@engage/data-fetch-v2/fetchers';
import { PELOTON_PLATFORM } from '@webtv/env';
import { engageApi, apiClient, localApi } from './singletons';
export var AuthFetchers = toAuthFetchers(engageApi);
export var ClassFetchers = toClassFetchers(engageApi);
export var FavoritesFetchers = toFavoritesFetchers(engageApi);
export var FiltersFetchers = toFiltersFetchers(engageApi);
export var MetadataFetchers = toMetadataFetchers(engageApi);
export var PelotonFetchers = toPelotonFetchers(engageApi);
export var PostclassLeaderboardFetchers = toPostclassLeaderboardFetchers(engageApi);
export var StatsTokenFetchers = toStatsTokenFetchers(engageApi);
export var StreamFetchers = toStreamFetchers(engageApi);
export var SubscriptionsFetchers = toSubscriptionsFetchers(apiClient);
export var WorkoutsFetchers = toWorkoutFetchers(engageApi, PELOTON_PLATFORM);
export var BrowseCategoryFetchers = toBrowseCategoryFetchers(engageApi);
export var UsersFetchers = toUsersFetchers(engageApi);
export var VoiceFetchers = toVoiceFetchers(localApi);
export var ContractAgreementsFetchers = toContractAgreementsFetchers(engageApi);